"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9z"
}), 'Hexagon');